
    import '/home/ec2-user/Youlify-Design/CHANGELOG.en-US.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__CHANGELOG.en-US.md__en-US" */'/home/ec2-user/Youlify-Design/CHANGELOG.en-US.md?type=demo')
};